// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609101646/js/" + chunkId + "." + {"44":"5cb9b2b1","225":"ac139969","481":"0c06bee9","486":"795ca148","770":"46d1beec"}[chunkId] + ".0.6029876673531722.chunk.js";
};